
/**
 * Pictoirel Design Studio — Toast Notification System (Phase 18)
 * 
 * Non-blocking feedback for:
 *  - Overflow photos moved to tray (Phase 11 Layout Templates)
 *  - Draft restore notifications (Phase 0A)
 *  - Bleed zone warnings (Phase 0E)
 *  - Photo replace confirmations (Phase 12A)
 *  - General user feedback
 *
 * Usage:
 *   showToast('Your message here');
 *   showToast('Warning!', 5000);               // 5-second duration
 *   showToast('Saved ✓', 2000, 'success');      // success style
 *   showToast('Low resolution', 4000, 'warn');   // warning style
 */
(function () {
  'use strict';

  // — Inject toast CSS once —
  const style = document.createElement('style');
  style.textContent = `
    #ds-toast-container {
      position: fixed;
      bottom: 28px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99999999;
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      gap: 8px;
      pointer-events: none;
    }
    .ds-toast {
      background: #1a1a1a;
      color: #fff;
      padding: 10px 22px;
      border-radius: 10px;
      font-size: 13px;
      font-weight: 600;
      font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
      letter-spacing: 0.01em;
      box-shadow: 0 4px 24px rgba(0,0,0,0.22), 0 1px 4px rgba(0,0,0,0.12);
      opacity: 0;
      transform: translateY(12px) scale(0.96);
      transition: opacity 0.22s cubic-bezier(0.4,0,0.2,1), transform 0.22s cubic-bezier(0.4,0,0.2,1);
      pointer-events: auto;
      max-width: 420px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ds-toast.is-visible {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    .ds-toast.is-exiting {
      opacity: 0;
      transform: translateY(-8px) scale(0.96);
    }
    .ds-toast.ds-toast--success {
      background: #16a34a;
    }
    .ds-toast.ds-toast--warn {
      background: #d97706;
    }
    .ds-toast.ds-toast--error {
      background: #dc2626;
    }
  `;
  document.head.appendChild(style);

  // — Create container lazily —
  function getContainer() {
    let container = document.getElementById('ds-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'ds-toast-container';
      document.body.appendChild(container);
    }
    return container;
  }

  let pctToastLastKey = '';
  let pctToastLastAt = 0;

  /**
   * Show a non-blocking toast notification.
   * @param {string} message  — The text to display
   * @param {number} duration — How long to show (ms), default 3000
   * @param {string} type     — 'default' | 'success' | 'warn' | 'error'
   */
  window.showToast = function (message, duration, type) {
    duration = duration || 3000;
    type = type || 'default';
    const uploadModal = document.getElementById('firebase-upload-modal');
    if ((window.uploadBatchInProgress || (uploadModal && uploadModal.classList.contains('is-open'))) && type === 'error') return;
    const toastKey = type + '|' + message;
    const now = Date.now();
    if (toastKey === pctToastLastKey && now - pctToastLastAt < 1800) return;
    pctToastLastKey = toastKey;
    pctToastLastAt = now;

    const container = getContainer();
    const toast = document.createElement('div');
    toast.className = 'ds-toast' + (type !== 'default' ? ' ds-toast--' + type : '');
    toast.textContent = message;
    container.appendChild(toast);

    // Trigger enter animation
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
    });

    // Schedule exit
    const timer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.classList.add('is-exiting');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 250);
    }, duration);

    // Allow manual dismiss on click
    toast.addEventListener('click', function () {
      clearTimeout(timer);
      toast.classList.remove('is-visible');
      toast.classList.add('is-exiting');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 250);
    });

    // Cap max visible toasts at 4
    const toasts = container.querySelectorAll('.ds-toast');
    if (toasts.length > 4) {
      const oldest = toasts[0];
      if (oldest && oldest.parentNode) oldest.parentNode.removeChild(oldest);
    }
  };
})();
